<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block"> {{heading}}</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <div class="body" style="padding: 16px 24px 16px 24px;">
        <div class="form-row">
            <div class="form-col">
                <label class="catlabel">Root Cause:<span style="color:#ff0000">*</span></label>
                <input type="text" class="category" style="width: 100%;" [(ngModel)]="rootCause">
            </div>
        </div>
        <div class="form-row">
            <div class="form-col">
                <label class="catlabel">Planned Blowout:</label>
                <select class="category" style="width: 100%;" [(ngModel)]="plannedBlowout">
                    <option *ngFor="let booleanVal of yesNoList" [value]="booleanVal.id">
                        {{booleanVal.value}}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-row">
            <div class="form-col">
                <label class="catlabel">OWK Blowout:</label>
                <select class="category" style="width: 100%;" [(ngModel)]="owkBlowout">
                    <option *ngFor="let booleanVal of yesNoList" [value]="booleanVal.id">
                        {{booleanVal.value}}
                    </option>
                </select>
            </div>
        </div>
    </div>
    <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
    <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
        <button (click)="onNoClick()" class="mCancel">CANCEL</button>
        <button mat-raised-button class="black-btn" style="display: inline;" (click)="saveClick()">SAVE</button>
    </div>
</div>